// extracted by mini-css-extract-plugin
export var copyableField = "_ov-4";
export var customerBadge = "_ov-0";
export var customerInfoTitle = "_ov-2";
export var details = "_ov-1";
export var dropdownContainer = "_ov-5";
export var dropdownImage = "_ov-6";
export var editAssigneeForm = "_ov-a";
export var editButton = "_ov-3";
export var email = "_ov-7";
export var hidden = "_ov-d";
export var input = "_ov-8";
export var saveButton = "_ov-b";
export var shopifyIcon = "_ov-c";
export var suggestionBadge = "_ov-e";
export var suggestionText = "_ov-f";
export var username = "_ov-9";